import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import ContactSection from "@/sections/ContactSection";

export default function ContactPage() {
  return (
    <>
      <SEO
        title="Contact — Get a Free Consultation"
        description="Contact DiziTeQ Innovative Solutions in Bengaluru. Call +91 81232 52171, WhatsApp us or book a free consultation to grow your business online."
        path="/contact"
      />
      <PageHeader
        eyebrow="Contact us"
        title="Book your free"
        highlight="consultation"
        subtitle="Tell us about your business and goals. We'll respond within 24 hours with a plan to grow your leads."
      />
      <ContactSection />
    </>
  );
}
